"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublicKeyUtils = void 0;
class PublicKeyUtils {
  static isBase58(value) {
    return /^[A-HJ-NP-Za-km-z1-9]*$/.test(value);
  }
  static orderKeys() {
    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }
    return keys.sort(comparePublicKeys);
  }
}
exports.PublicKeyUtils = PublicKeyUtils;
function comparePublicKeys(key1, key2) {
  const bytes1 = key1.toBytes();
  const bytes2 = key2.toBytes();
  if (bytes1.byteLength !== bytes2.byteLength) {
    return bytes1.byteLength - bytes2.byteLength;
  }
  for (let i = 0; i < bytes1.byteLength; i++) {
    let byte1 = bytes1[i];
    let byte2 = bytes2[i];
    if (byte1 !== byte2) {
      return byte1 - byte2;
    }
  }
  return 0;
}
//# sourceMappingURL=public-key-utils.js.map